import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageSquare, User } from "lucide-react";
import { DiscussionReplies } from "./DiscussionReplies";
import type { Tables } from "@/integrations/supabase/types";

interface DiscussionCardProps {
  discussion: Tables<"property_discussions"> & {
    profiles: Pick<Tables<"profiles">, "first_name" | "last_name"> | null;
    replies: (Tables<"property_discussions"> & {
      profiles: Pick<Tables<"profiles">, "first_name" | "last_name"> | null;
    })[];
  };
  onReply: () => void;
}

export const DiscussionCard = ({ discussion, onReply }: DiscussionCardProps) => {
  return (
    <Card key={discussion.id} className="p-4">
      <div className="flex items-start space-x-3">
        <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
          <User className="h-6 w-6 text-gray-400" />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <p className="font-medium">
              {discussion.profiles?.first_name} {discussion.profiles?.last_name}
            </p>
            <p className="text-sm text-muted-foreground">
              {new Date(discussion.created_at || "").toLocaleDateString()}
            </p>
          </div>
          <h3 className="font-medium mt-1">{discussion.title}</h3>
          <p className="text-muted-foreground mt-1">{discussion.content}</p>

          {discussion.replies?.length > 0 && (
            <DiscussionReplies replies={discussion.replies} />
          )}

          <Button
            variant="ghost"
            size="sm"
            className="mt-2"
            onClick={onReply}
          >
            <MessageSquare className="h-4 w-4 mr-1" />
            Reply
          </Button>
        </div>
      </div>
    </Card>
  );
};